module.exports = __webpack_public_path__ + "img/图层 22.515d7cb9.png";